"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plugin = exports.CurrentModel = exports.Model = exports.Hotkey = exports.Expression = exports.CustomParameter = exports.Parameter = void 0;
var utils_1 = require("./utils");
var types_1 = require("./types");
var Parameter = (function () {
    function Parameter(vts, model, name, value, min, max, defaultValue) {
        this.vts = vts;
        this.model = model;
        this.name = name;
        this.value = value;
        this.min = min;
        this.max = max;
        this.defaultValue = defaultValue;
    }
    Parameter.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, value, min, max, defaultValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.vts.apiClient.parameterValue({ name: this.name })];
                    case 1:
                        _a = _b.sent(), value = _a.value, min = _a.min, max = _a.max, defaultValue = _a.defaultValue;
                        this.value = value;
                        this.min = min;
                        this.max = max;
                        this.defaultValue = defaultValue;
                        return [2, this];
                }
            });
        });
    };
    Parameter.prototype.setValue = function (value, weight) {
        if (weight === void 0) { weight = 1; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.injectParameterData({ parameterValues: [{ id: this.name, weight: weight, value: value }] })];
                    case 1:
                        _a.sent();
                        this.value = value;
                        return [2, this];
                }
            });
        });
    };
    return Parameter;
}());
exports.Parameter = Parameter;
var CustomParameter = (function (_super) {
    __extends(CustomParameter, _super);
    function CustomParameter(vts, model, name, value, min, max, defaultValue, explanation) {
        var _this = _super.call(this, vts, model, name, value, min, max, defaultValue) || this;
        _this.explanation = explanation;
        return _this;
    }
    CustomParameter.prototype.update = function (_a) {
        var min = _a.min, max = _a.max, defaultValue = _a.defaultValue;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.vts.apiClient.parameterCreation({ parameterName: this.name, explanation: this.explanation, min: min !== null && min !== void 0 ? min : this.min, max: max !== null && max !== void 0 ? max : this.max, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : this.defaultValue })];
                    case 1:
                        _b.sent();
                        this.min = min !== null && min !== void 0 ? min : this.min;
                        this.max = max !== null && max !== void 0 ? max : this.max;
                        this.defaultValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : this.defaultValue;
                        return [2, this];
                }
            });
        });
    };
    CustomParameter.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.parameterDeletion({ parameterName: this.name })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    return CustomParameter;
}(Parameter));
exports.CustomParameter = CustomParameter;
var Expression = (function () {
    function Expression(vts, model, name, file, active, deactivateWhenKeyIsLetGo, autoDeactivateAfterSeconds, secondsRemaining, usedInHotkeys, parameters) {
        this.vts = vts;
        this.model = model;
        this.name = name;
        this.file = file;
        this.active = active;
        this.deactivateWhenKeyIsLetGo = deactivateWhenKeyIsLetGo;
        this.autoDeactivateAfterSeconds = autoDeactivateAfterSeconds;
        this.secondsRemaining = secondsRemaining;
        this.usedInHotkeys = usedInHotkeys;
        this.parameters = parameters;
    }
    Expression.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var expressions, expr;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.expressionState({ details: true, expressionFile: this.file })];
                    case 1:
                        expressions = (_a.sent()).expressions;
                        expr = expressions.find(function (e) { return e.file === _this.file; });
                        if (expr) {
                            this.active = expr.active;
                            this.deactivateWhenKeyIsLetGo = expr.deactivateWhenKeyIsLetGo;
                            this.autoDeactivateAfterSeconds = expr.autoDeactivateAfterSeconds;
                            this.secondsRemaining = expr.secondsRemaining;
                            this.usedInHotkeys = expr.usedInHotkeys;
                            this.parameters = expr.parameters;
                        }
                        return [2, this];
                }
            });
        });
    };
    Expression.prototype.activate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.expressionActivation({ expressionFile: this.file, active: true })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Expression.prototype.deactivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.expressionActivation({ expressionFile: this.file, active: true })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Expression.prototype.hotkeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var hotkeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.model.hotkeys()];
                    case 1:
                        hotkeys = _a.sent();
                        return [2, this.usedInHotkeys.map(function (h) { return hotkeys.find(function (hk) { return hk.id === h.id; }); }).filter(utils_1.filterFalsy)];
                }
            });
        });
    };
    Expression.prototype.live2DParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.model.live2DParameters()];
                    case 1:
                        params = _a.sent();
                        return [2, this.parameters.map(function (p) { return params.find(function (pm) { return pm.name === p.id; }); }).filter(utils_1.filterFalsy)];
                }
            });
        });
    };
    return Expression;
}());
exports.Expression = Expression;
var Hotkey = (function () {
    function Hotkey(vts, model, id, type, name, file, description) {
        this.vts = vts;
        this.model = model;
        this.id = id;
        this.type = type;
        this.name = name;
        this.file = file;
        this.description = description;
    }
    Hotkey.prototype.trigger = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.hotkeyTrigger({ hotkeyID: this.id })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    return Hotkey;
}());
exports.Hotkey = Hotkey;
var Model = (function () {
    function Model(vts, id, name, vtsModelName, vtsModelIconName) {
        this.vts = vts;
        this.id = id;
        this.name = name;
        this.vtsModelName = vtsModelName;
        this.vtsModelIconName = vtsModelIconName;
    }
    Model.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.modelLoad({ modelID: this.id })];
                    case 1:
                        _a.sent();
                        return [4, this.vts.currentModel()];
                    case 2: return [2, (_a.sent())];
                }
            });
        });
    };
    return Model;
}());
exports.Model = Model;
var CurrentModel = (function () {
    function CurrentModel(vts, id, name, vtsModelName, live2DModelName, modelLoadTime, timeSinceModelLoaded, numberOfLive2DParameters, numberOfLive2DArtmeshes, hasPhysicsFile, numberOfTextures, textureResolution, positionX, positionY, rotation, size) {
        this.vts = vts;
        this.id = id;
        this.name = name;
        this.vtsModelName = vtsModelName;
        this.live2DModelName = live2DModelName;
        this.modelLoadTime = modelLoadTime;
        this.timeSinceModelLoaded = timeSinceModelLoaded;
        this.numberOfLive2DParameters = numberOfLive2DParameters;
        this.numberOfLive2DArtmeshes = numberOfLive2DArtmeshes;
        this.hasPhysicsFile = hasPhysicsFile;
        this.numberOfTextures = numberOfTextures;
        this.textureResolution = textureResolution;
        this.positionX = positionX;
        this.positionY = positionY;
        this.rotation = rotation;
        this.size = size;
    }
    CurrentModel.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var m;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.currentModel()];
                    case 1:
                        m = _a.sent();
                        if (!m.modelLoaded)
                            return [2, null];
                        return [2, new CurrentModel(this.vts, m.modelID, m.modelName, m.vtsModelName, m.live2DModelName, m.modelLoadTime, m.timeSinceModelLoaded, m.numberOfLive2DParameters, m.numberOfLive2DArtmeshes, m.hasPhysicsFile, m.numberOfTextures, m.textureResolution, m.modelPosition.positionX, m.modelPosition.positionY, m.modelPosition.rotation, m.modelPosition.size)];
                }
            });
        });
    };
    CurrentModel.prototype.position = function () {
        return __awaiter(this, void 0, void 0, function () {
            var m;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.currentModel()];
                    case 1:
                        m = _a.sent();
                        if (!m.modelLoaded)
                            return [2, null];
                        return [2, m.modelPosition];
                }
            });
        });
    };
    CurrentModel.prototype.moveBy = function (duration, by) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.moveModel({
                            timeInSeconds: duration,
                            valuesAreRelativeToModel: true,
                            positionX: by.offsetX,
                            positionY: by.offsetY,
                            rotation: by.rotateBy,
                            size: by.sizeChange,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    CurrentModel.prototype.moveTo = function (duration, to) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.moveModel({
                            timeInSeconds: duration,
                            valuesAreRelativeToModel: false,
                            positionX: to.positionX,
                            positionY: to.positionY,
                            rotation: to.rotation,
                            size: to.size,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    CurrentModel.prototype.expressions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var expressions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.expressionState({ details: true })];
                    case 1:
                        expressions = (_a.sent()).expressions;
                        return [2, expressions.map(function (e) { return new Expression(_this.vts, _this, e.name, e.file, e.active, e.deactivateWhenKeyIsLetGo, e.autoDeactivateAfterSeconds, e.secondsRemaining, e.usedInHotkeys, e.parameters); })];
                }
            });
        });
    };
    CurrentModel.prototype.hotkeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var availableHotkeys;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.hotkeysInCurrentModel()];
                    case 1:
                        availableHotkeys = (_a.sent()).availableHotkeys;
                        return [2, availableHotkeys.map(function (k) { return new Hotkey(_this.vts, _this, k.hotkeyID, k.type, k.name, k.file, k.description); })];
                }
            });
        });
    };
    CurrentModel.prototype.artMeshNames = function () {
        return __awaiter(this, void 0, void 0, function () {
            var artMeshNames;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.artMeshList()];
                    case 1:
                        artMeshNames = (_a.sent()).artMeshNames;
                        return [2, artMeshNames];
                }
            });
        });
    };
    CurrentModel.prototype.artMeshTags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var artMeshTags;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.artMeshList()];
                    case 1:
                        artMeshTags = (_a.sent()).artMeshTags;
                        return [2, artMeshTags];
                }
            });
        });
    };
    CurrentModel.prototype.colorTint = function (color, match) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.vts.apiClient.colorTint({
                            colorTint: { colorR: color.r, colorG: color.g, colorB: color.b, colorA: (_a = color.a) !== null && _a !== void 0 ? _a : 255, mixWithSceneLightingColor: color.mixWithSceneLightingColor },
                            artMeshMatcher: __assign({ tintAll: !match }, match)
                        })];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    CurrentModel.prototype.live2DParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var parameters;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.live2DParameterList()];
                    case 1:
                        parameters = (_a.sent()).parameters;
                        return [2, parameters.map(function (p) { return new Parameter(_this.vts, _this, p.name, p.value, p.min, p.max, p.defaultValue); })];
                }
            });
        });
    };
    CurrentModel.prototype.customParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var customParameters;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.inputParameterList()];
                    case 1:
                        customParameters = (_a.sent()).customParameters;
                        return [2, customParameters.map(function (p) { return new CustomParameter(_this.vts, _this, p.name, p.value, p.min, p.max, p.defaultValue, p.addedBy); })];
                }
            });
        });
    };
    CurrentModel.prototype.defaultParameters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var defaultParameters;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.inputParameterList()];
                    case 1:
                        defaultParameters = (_a.sent()).defaultParameters;
                        return [2, defaultParameters.map(function (p) { return new Parameter(_this.vts, _this, p.name, p.value, p.min, p.max, p.defaultValue); })];
                }
            });
        });
    };
    CurrentModel.prototype.createParameter = function (name, explanation, min, max, defaultValue) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.vts.apiClient.parameterCreation({ parameterName: name, explanation: explanation, min: min, max: max, defaultValue: defaultValue })];
                    case 1:
                        _a.sent();
                        return [2, new CustomParameter(this.vts, this, name, defaultValue, min, max, defaultValue, this.vts.name)];
                }
            });
        });
    };
    return CurrentModel;
}());
exports.CurrentModel = CurrentModel;
var Plugin = (function () {
    function Plugin(apiClient, name, author, icon, authenticationToken, onAuthenticate) {
        this.name = name;
        this.author = author;
        this.icon = icon;
        this.authenticationToken = authenticationToken;
        this.onAuthenticate = onAuthenticate;
        this.isApiEnabled = null;
        this.isAuthenticated = null;
        this.isAuthenticating = null;
        this.ongoingAuthCall = null;
        this.apiClient = this.wrapClient(apiClient);
    }
    Plugin.prototype.checkApiState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, active, currentSessionAuthenticated;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.isApiEnabled !== true)) return [3, 2];
                        return [4, this.apiClient.apiState()];
                    case 1:
                        _a = _b.sent(), active = _a.active, currentSessionAuthenticated = _a.currentSessionAuthenticated;
                        this.isApiEnabled = active;
                        if (currentSessionAuthenticated)
                            this.isAuthenticated = true;
                        _b.label = 2;
                    case 2:
                        if (!this.isApiEnabled)
                            throw new types_1.VTubeStudioError({ errorID: types_1.ErrorCode.InternalClientError, message: 'API access is disabled.' }, 'N/A');
                        return [2];
                }
            });
        });
    };
    Plugin.prototype.authenticate = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var auth, e_1, authenticationToken, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.isAuthenticated !== true && this.isAuthenticating !== true)) return [3, 8];
                        this.isAuthenticating = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        if (!(this.authenticationToken !== undefined)) return [3, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4, this.apiClient.authentication({ authenticationToken: this.authenticationToken, pluginName: this.name, pluginDeveloper: this.author })];
                    case 3:
                        auth = _b.sent();
                        if (!auth.authenticated)
                            throw new types_1.VTubeStudioError({ errorID: types_1.ErrorCode.TokenRequestDenied, message: auth.reason }, 'N/A');
                        this.isAuthenticated = true;
                        this.isAuthenticating = false;
                        return [2];
                    case 4:
                        e_1 = _b.sent();
                        console.error(e_1);
                        return [3, 5];
                    case 5: return [4, this.apiClient.authenticationToken({ pluginName: this.name, pluginDeveloper: this.author, pluginIcon: this.icon })];
                    case 6:
                        authenticationToken = (_b.sent()).authenticationToken;
                        this.authenticationToken = authenticationToken;
                        this.isAuthenticated = true;
                        this.isAuthenticating = false;
                        (_a = this.onAuthenticate) === null || _a === void 0 ? void 0 : _a.call(this, authenticationToken);
                        return [3, 8];
                    case 7:
                        e_2 = _b.sent();
                        console.error(e_2);
                        this.isAuthenticated = null;
                        this.isAuthenticating = false;
                        return [3, 8];
                    case 8:
                        if (!this.isAuthenticated)
                            throw new types_1.VTubeStudioError({ errorID: types_1.ErrorCode.InternalClientError, message: 'Plugin could not authenticate.' }, 'N/A');
                        return [2];
                }
            });
        });
    };
    Plugin.prototype.wrapClient = function (apiClient) {
        var excludedKeys = {
            apiState: true,
            authentication: true,
            authenticationToken: true,
        };
        var wrappedClient = __assign({}, apiClient);
        Object.setPrototypeOf(wrappedClient, apiClient);
        var keys = Object.keys(wrappedClient);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            if (typeof wrappedClient[key] === 'function' && !excludedKeys[key]) {
                wrappedClient[key] = this.wrapSafeCall(wrappedClient[key]).bind(wrappedClient);
            }
        }
        return wrappedClient;
    };
    Plugin.prototype.wrapSafeCall = function (call) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.safeCall.apply(_this, __spreadArray([call], args));
        };
    };
    Plugin.prototype.safeCall = function (call) {
        var _a, _b;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 4, , 8]);
                        return [4, this.checkApiState()];
                    case 1:
                        _c.sent();
                        return [4, ((_a = this.ongoingAuthCall) !== null && _a !== void 0 ? _a : (this.ongoingAuthCall = this.authenticate()))];
                    case 2:
                        _c.sent();
                        this.ongoingAuthCall = null;
                        return [4, call.apply(void 0, args)];
                    case 3: return [2, _c.sent()];
                    case 4:
                        e_3 = _c.sent();
                        if (!(e_3 instanceof types_1.VTubeStudioError)) return [3, 7];
                        if (e_3.data.errorID === types_1.ErrorCode.APIAccessDeactivated) {
                            this.isApiEnabled = false;
                        }
                        if (!(e_3.data.errorID === types_1.ErrorCode.RequestRequiresAuthetication)) return [3, 7];
                        this.isAuthenticated = null;
                        this.isAuthenticating = null;
                        return [4, ((_b = this.ongoingAuthCall) !== null && _b !== void 0 ? _b : (this.ongoingAuthCall = this.authenticate()))];
                    case 5:
                        _c.sent();
                        this.ongoingAuthCall = null;
                        return [4, call.apply(void 0, args)];
                    case 6: return [2, _c.sent()];
                    case 7: throw e_3;
                    case 8: return [2];
                }
            });
        });
    };
    Plugin.prototype.apiState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.apiState()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Plugin.prototype.statistics = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.statistics()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Plugin.prototype.folderNames = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.vtsFolderInfo()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Plugin.prototype.models = function () {
        return __awaiter(this, void 0, void 0, function () {
            var availableModels;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.availableModels()];
                    case 1:
                        availableModels = (_a.sent()).availableModels;
                        return [2, availableModels.map(function (m) { return new Model(_this, m.modelID, m.modelName, m.vtsModelName, m.vtsModelIconName); })];
                }
            });
        });
    };
    Plugin.prototype.currentModel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var m;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.currentModel()];
                    case 1:
                        m = _a.sent();
                        if (!m.modelLoaded)
                            return [2, null];
                        return [2, new CurrentModel(this, m.modelID, m.modelName, m.vtsModelName, m.live2DModelName, m.modelLoadTime, m.timeSinceModelLoaded, m.numberOfLive2DParameters, m.numberOfLive2DArtmeshes, m.hasPhysicsFile, m.numberOfTextures, m.textureResolution, m.modelPosition.positionX, m.modelPosition.positionY, m.modelPosition.rotation, m.modelPosition.size)];
                }
            });
        });
    };
    Plugin.prototype.isFaceFound = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.faceFound()];
                    case 1: return [2, (_a.sent()).found];
                }
            });
        });
    };
    Plugin.prototype.sceneColorOverlayInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.sceneColorOverlayInfo()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    Plugin.prototype.ndiConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ndiActive, useNDI5, useCustomResolution, customWidthNDI, customHeightNDI;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.apiClient.ndiConfig({
                            setNewConfig: false,
                            ndiActive: false,
                            useNDI5: false,
                            useCustomResolution: false,
                            customWidthNDI: -1,
                            customHeightNDI: -1,
                        })];
                    case 1:
                        _a = _b.sent(), ndiActive = _a.ndiActive, useNDI5 = _a.useNDI5, useCustomResolution = _a.useCustomResolution, customWidthNDI = _a.customWidthNDI, customHeightNDI = _a.customHeightNDI;
                        return [2, { ndiActive: ndiActive, useNDI5: useNDI5, useCustomResolution: useCustomResolution, customWidthNDI: customWidthNDI, customHeightNDI: customHeightNDI }];
                }
            });
        });
    };
    Plugin.prototype.updateNDIConfig = function (ndiActive, useNDI5, useCustomResolution, customWidthNDI, customHeightNDI) {
        if (customWidthNDI === void 0) { customWidthNDI = -1; }
        if (customHeightNDI === void 0) { customHeightNDI = -1; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.apiClient.ndiConfig({
                            setNewConfig: true,
                            ndiActive: ndiActive,
                            useNDI5: useNDI5,
                            useCustomResolution: useCustomResolution,
                            customWidthNDI: customWidthNDI,
                            customHeightNDI: customHeightNDI,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    return Plugin;
}());
exports.Plugin = Plugin;
